import React from 'react'
import { useSearchParams } from 'react-router-dom'

import SelectBox from '@/compoments/common/SelectBox'
import SelectBoxAsynk from '@/compoments/common/SelectBoxAsynk'
import { useLazyGetTechniciansQuery } from '@/services/executives/executives'
import { optionsRating } from '@/utils/selectsOptionsConst'

const Filters = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [getTechnicians] = useLazyGetTechniciansQuery()
    const loadOptionsTechnicians = async (
        search: string,
        loadedOptions: any,
        { page }: { page: number },
    ) => {
        const res = await getTechnicians(
            `page=${page}&search=${search}`,
        ).unwrap()

        return {
            options:
                res?.data.map((technician) => ({
                    value: technician.id,
                    label: technician.fullName,
                })) || [],
            hasMore: page != res?.pagination?.maxPages, // флаг, показывающий, есть ли еще данные
            additional: {
                page: page + 1, // увеличиваем номер страницы для следующего запроса
            },
        }
    }

    const filterHandler = (
        name: string,
        value: string | number | undefined,
    ) => {
        setSearchParams((prev: URLSearchParams) => {
            prev.set('page', '1')
            if (value) {
                prev.set(name, String(value))
            } else {
                prev.delete(name)
            }
            return prev
        })
    }

    return (
        <div className="table-tools">
            <SelectBox
                wrapperClassName="select--outline input--sm"
                placeholder="Rating"
                options={optionsRating}
                onChange={(option) => filterHandler('rating', option?.value)}
            />
            <SelectBoxAsynk
                wrapperClassName="select--outline input--sm"
                placeholder="Technician"
                fetchFunk={loadOptionsTechnicians}
                onChange={(option) =>
                    filterHandler('technician', option?.value)
                }
            />
        </div>
    )
}

export default Filters
